import script from "./DocsFilterType.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocsFilterType.vue?vue&type=script&setup=true&lang=ts"

import "./DocsFilterType.vue?vue&type=style&index=0&id=2f0f9164&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0f9164"]])

export default __exports__